import { TranslateCommonService } from './services/translate.service';
import { StorageService } from './services/storage.service';
import { ColorSchemaService } from './services/color-schema.service';
import { Store } from '@ngrx/store';
import { from, switchMap } from 'rxjs';
import { first, tap } from 'rxjs/operators';
import { TextZoomService } from './services/text-zoom.service';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { Capacitor } from '@capacitor/core';

export function initApp(
    translateCommonService: TranslateCommonService,
    storageService: StorageService,
    colorSchemaService: ColorSchemaService,
    store: Store,
    textZoomService: TextZoomService,
) {
    return from(storageService.create()).pipe(
        tap(() => {
            if (Capacitor.getPlatform() !== 'web') {
                ScreenOrientation.lock({ orientation: 'portrait' }).then();
                textZoomService
                    .getPreferred()
                    .pipe(
                        first(),
                        switchMap((v) => {
                            if (v.value > 1.2) {
                                return textZoomService.set(1.2);
                            }

                            return textZoomService.set(v.value);
                        }),
                    )
                    .subscribe();
            }
            colorSchemaService.initSchema();
            translateCommonService.initCurrentLang();
            // store.dispatch(initAppState());
        }),
    );
}
